import {environment} from '../../environments/environment';

export const Utilities = {
  currency: () => environment.deployment.region.currency === 'ILS' ? 'NIS' : environment.deployment.region.currency
};
